<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11,2C10.719999999999999,2,10.469999999999999,2.11,10.29,2.29C10.29,2.29,7.59,5,7.59,5C7.59,5,5,5,5,5C4.45,5,4,5.45,4,6C4,6,4,10,4,10C4,10.55,4.45,11,5,11C5,11,7.59,11,7.59,11C7.59,11,10.3,13.71,10.3,13.71C10.469999999999999,13.89,10.719999999999999,14,11,14C11.55,14,12,13.55,12,13C12,13,12,3,12,3C12,2.45,11.55,2,11,2C11,2,11,2,11,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'VolumeOff',
} as DefineComponent
</script>
